import React, { useState } from 'react';
import {
  AppLayout,
  ContentLayout,
  SideNavigation,
  BreadcrumbGroup,
  Tabs,
  Header,
  SpaceBetween,
  Table,
  Box,
} from '@cloudscape-design/components';
import { InitialRecommendationsTab } from './tabs/InitialRecommendationsTab';
import { DomainSynthesisTab } from './tabs/DomainSynthesisTab';
import { FinalArchitectureTab } from './tabs/FinalArchitectureTab';
import entityDomainData from './data/entity_domain_analysis.json';

export function DomainAnalysisPage() {
  const [selectedProject, setSelectedProject] = useState(null);
  const [activeTab, setActiveTab] = useState('recommendations');

  // Navigation structure
  const navItems = [
    { type: 'link', text: 'Projects', href: '/jobs' },
    {
      type: 'section',
      text: 'Domain Analysis',
      items: [
        { type: 'link', text: 'Analysis Dashboard', href: '/domain-analysis' },
        {
          type: 'section',
          text: 'Recent Projects',
          items: [
            { type: 'link', text: 'ECommerce Platform', href: '/domain-analysis/ecommerce' },
            { type: 'link', text: 'Banking Portal', href: '/domain-analysis/banking' },
            // More projects...
          ]
        }
      ]
    }
  ];

  // Breadcrumb items based on selection
  const breadcrumbItems = [
    { text: 'Domain Analysis', href: '/domain-analysis' },
    ...(selectedProject ? [{ text: selectedProject, href: `/domain-analysis/${selectedProject}` }] : []),
    ...(activeTab !== 'overview' ? [{ text: activeTab }] : [])
  ];

  return (
    <AppLayout
      navigation={
        <SideNavigation
          activeHref={selectedProject ? `/domain-analysis/${selectedProject}` : '/domain-analysis'}
          header={{ text: 'Navigation' }}
          items={navItems}
        />
      }
      content={
        <ContentLayout
          header={
            <SpaceBetween size="m">
              <BreadcrumbGroup items={breadcrumbItems} />
              {selectedProject ? (
                <Header
                  variant="h1"
                  description="Domain analysis results and insights"
                >
                  {selectedProject}
                </Header>
              ) : (
                <ProjectSelectionView onSelect={setSelectedProject} />
              )}
            </SpaceBetween>
          }
        >
          {selectedProject ? (
            <Tabs
              tabs={[
                {
                  label: "Initial Recommendations",
                  id: "recommendations",
                  content: <InitialRecommendationsTab entityDomainData={entityDomainData}/>
                },
                {
                  label: "Domain Synthesis",
                  id: "synthesis",
                  content: <DomainSynthesisTab />
                },
                {
                  label: "Final Architecture",
                  id: "final",
                  content: <FinalArchitectureTab />
                }
              ]}
              activeTabId={activeTab}
              onChange={({ detail }) => setActiveTab(detail.activeTabId)}
            />
          ) : null}
        </ContentLayout>
      }
      toolsPanel={selectedProject && <AnalysisToolsPanel project={selectedProject} />}
      contentType="default"
      toolsOpen={false}
    />
  );
};

// Project Selection View when no project is selected
const ProjectSelectionView = ({ onSelect }) => {
  return (
    <SpaceBetween size="l">
      <Header
        variant="h1"
        description="Select a project to view domain analysis results"
      >
        Domain Analysis Dashboard
      </Header>
      <Table
        columnDefinitions={[
          {
            id: 'name',
            header: 'Project name',
            cell: item => item.name,
            sortingField: 'name'
          },
          {
            id: 'status',
            header: 'Analysis status',
            cell: item => item.status
          },
          {
            id: 'lastUpdated',
            header: 'Last updated',
            cell: item => item.lastUpdated
          }
        ]}
        items={[
          {
            name: 'ECommerce Platform',
            status: 'Analysis complete',
            lastUpdated: '2 hours ago'
          },
          // More projects...
        ]}
        onSelectionChange={({ detail }) => 
          onSelect(detail.selectedItems[0]?.name)
        }
        selectionType="single"
      />
    </SpaceBetween>
  );
};

// Tools panel component
const AnalysisToolsPanel = ({ project }) => {
  return (
    <SpaceBetween size="l">
      {/* Tools panel content */}
    </SpaceBetween>
  );
};
